module.exports = __webpack_public_path__ + "img/gmo_gquest.895e773b.svg";